import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home, // 原来引用的地址
    redirect: '/Home', // 重定位后页面加载的页面
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home,
  },

  // 产品中心
  // 首页
  {
    path: '/product',
    name: 'product',
    meta: {
      menulist: [
        {
          name: '产品中心',
          path: '',
        },
        {
          name: '首页',
          path: '/product',
        },
      ]
    },
    component: () => import('../views/product/product.vue'),
  },
  // 智慧河湖
  {
    path: '/lake',
    name: 'lake',
    meta: {
      menulist: [
        {
          name: '产品中心',
          path: '',
        },
        {
          name: '首页',
          path: '/product',
        },
        {
          name: '智慧河湖',
          path: '/lake',
        },
      ]
    },
    component: () => import('../views/product/lake.vue'),
  },

  // 智慧消防
  {
    path: '/fireProtection',
    name: 'fireProtection',
    meta: {
      menulist: [
        {
          name: '产品中心',
          path: '',
        },
        {
          name: '首页',
          path: '/product',
        },
        {
          name: '智慧消防',
          path: '/fireProtection',
        },
      ]
    },
    component: () => import('../views/product/fireProtection.vue'),
  },

  // 智慧农业
  {
    path: '/agriculture',
    name: 'agriculture',
    meta: {
      menulist: [
        {
          name: '产品中心',
          path: '',
        },
        {
          name: '首页',
          path: '/product',
        },
        {
          name: '智慧消防',
          path: '/fireProtection',
        },
        {
          name: '智慧农业',
          path: '/agriculture',
        },
      ]
    },
    component: () => import('../views/product/agriculture.vue'),
  },

  // 智慧社区
  {
    path: '/community',
    name: 'community',
    meta: {
      menulist: [
        {
          name: '产品中心',
          path: '',
        },
        {
          name: '首页',
          path: '/product',
        },
        {
          name: '智慧消防',
          path: '/fireProtection',
        },
        {
          name: '智慧农业',
          path: '/agriculture',
        },
        {
          name: '智慧社区',
          path: '/community',
        },
      ]
    },
    component: () => import('../views/product/community.vue'),
  },

  // 智慧养老
  {
    path: '/retirement',
    name: 'retirement',
    meta: {
      menulist: [
        {
          name: '产品中心',
          path: '',
        },
        {
          name: '首页',
          path: '/product',
        },
        {
          name: '智慧消防',
          path: '/fireProtection',
        },
        {
          name: '智慧农业',
          path: '/agriculture',
        },
        {
          name: '智慧社区',
          path: '/community',
        },
        {
          name: '智慧养老',
          path: '/retirement',
        },
      ]
    },
    component: () => import('../views/product/retirement.vue'),
  },

  // 企业名片
  {
    path: '/businessCard',
    name: 'businessCard',
    meta: {
      menulist: [
        {
          name: '产品中心',
          path: '',
        },
        {
          name: '首页',
          path: '/product',
        },
        {
          name: '智慧消防',
          path: '/fireProtection',
        },
        {
          name: '智慧农业',
          path: '/agriculture',
        },
        {
          name: '智慧社区',
          path: '/community',
        },
        {
          name: '智慧养老',
          path: '/retirement',
        },
        {
          name: '企业名片',
          path: '/businessCard',
        },
      ]
    },
    component: () => import('../views/product/businessCard.vue'),
  },

  // 放心消费一码通
  {
    path: '/storeYard',
    name: 'storeYard',
    meta: {
      menulist: [
        {
          name: '产品中心',
          path: '',
        },
        {
          name: '首页',
          path: '/product',
        },
        {
          name: '智慧消防',
          path: '/fireProtection',
        },
        {
          name: '智慧农业',
          path: '/agriculture',
        },
        {
          name: '智慧社区',
          path: '/community',
        },
        {
          name: '智慧养老',
          path: '/retirement',
        },
        {
          name: '企业名片',
          path: '/businessCard',
        },
        {
          name: '放心消费一码通',
          path: '/storeYard',
        },
      ]
    },
    component: () => import('../views/product/storeYard.vue'),
  },

  // 分销商城
  {
    path: '/distributionMall',
    name: 'distributionMall',
    meta: {
      menulist: [
        {
          name: '产品中心',
          path: '',
        },
        {
          name: '首页',
          path: '/product',
        },
        {
          name: '智慧消防',
          path: '/fireProtection',
        },
        {
          name: '智慧农业',
          path: '/agriculture',
        },
        {
          name: '智慧社区',
          path: '/community',
        },
        {
          name: '智慧养老',
          path: '/retirement',
        },
        {
          name: '企业名片',
          path: '/businessCard',
        },
        {
          name: '放心消费一码通',
          path: '/storeYard',
        },
        {
          name: '分销商城',
          path: '/distributionMall',
        },
      ]
    },
    component: () => import('../views/product/distributionMall.vue'),
  },

  // 工业经济检测运行平台
  {
    path: '/industrialEconomy',
    name: 'industrialEconomy',
    meta: {
      menulist: [
        {
          name: '产品中心',
          path: '',
        },
        {
          name: '首页',
          path: '/product',
        },
        {
          name: '工业经济监测平台',
          path: '/industrialEconomy',
        },
      ]
    },
    component: () => import('../views/product/industrialEconomy.vue'),
  },

  {
    path: '/customization',
    name: 'customization',
    meta: {
      menulist: [
        {
          name: '产品中心',
          path: '',
        },
        {
          name: '首页',
          path: '/product',
        },
        {
          name: 'App小程序定制开发',
          path: '/customization',
        },
      ]
    },
    component: () => import('../views/product/customization.vue'),
  },

  // 系统定制
  {
    path: '/systemCustomization',
    name: 'systemCustomization',
    meta: {
      menulist: [
        {
          name: '产品中心',
          path: '',
        },
        {
          name: '首页',
          path: '/product',
        },
        {
          name: '系统定制',
          path: '/systemCustomization',
        },
      ]
    },
    component: () => import('../views/product/systemCustomization.vue'),
  },
  // 智能除草机器人
  {
    path: '/weedingRobot',
    name: 'weedingRobot',
    meta: {
      menulist: [
        {
          name: '产品中心',
          path: '',
        },
        {
          name: '首页',
          path: '/product',
        },
        {
          name: '智能除草机器人',
          path: '/weedingRobot',
        },
      ]
    },
    component: () => import('../views/product/weedingRobot.vue'),
  },
  // 智能运输跟随机器人
  {
    path: '/transportRobot',
    name: 'transportRobot',
    meta: {
      menulist: [
        {
          name: '产品中心',
          path: '',
        },
        {
          name: '首页',
          path: '/product',
        },
        {
          name: '智能运输跟随机器人',
          path: '/transportRobot',
        },
      ]
    },
    component: () => import('../views/product/transportRobot.vue'),
  },

  // 合作共赢
  {
    path: '/cooperation',
    name: 'cooperation',
    meta: {
      menulist: [
        {
          name: '合作共赢',
          path: '/cooperation',
        }
      ]
    },
    component: () => import('../views/cooperation/cooperation.vue'),
  },

  // 关于我们
  {
    path: '/aboutUs',
    name: 'aboutUs',
    meta: {
      menulist: [
        {
          name: '关于我们',
          path: '/aboutUs',
        }
      ]
    },
    component: () => import('../views/aboutUs/aboutUs.vue'),
  },
  // 企业咨询
  {
    path: '/companyConsult',
    name: 'companyConsult',
    meta: {
      menulist: [
        {
          name: '企业咨询',
          path: '/companyConsult',
        },
      ]
    },
    component: () => import('../views/companyConsult/companyConsult.vue'),
  },

  // 企业咨询详情
  {
    path: '/companyConsultDetail',
    name: 'companyConsultDetail',
    meta: {
      menulist: [
        {
          name: '企业咨询详情',
          path: '/companyConsultDetail',
        },
      ]
    },
    component: () => import('../views/companyConsult/companyConsultDetail.vue'),
  },


  // 解决方案
  {
    path: '/solution',
    name: 'solution',
    meta: {
      menulist: [
        {
          name: '解决方案',
          path: '',
        },
        {
          name: '首页',
          path: '/solution',
        }
      ]
    },
    component: () => import('../views/solution/solution.vue'),
  },

  // 智慧消防解决方案
  {
    path: '/solutionFireProtection',
    name: 'solutionFireProtection',
    meta: {
      menulist: [
        {
          name: '解决方案',
          path: '',
        },
        {
          name: '首页',
          path: '/solution',
        },
        {
          name: '智慧消防解决方案',
          path: '/solutionFireProtection',
        }
      ]
    },
    component: () => import('../views/solution/solutionFireProtection.vue'),
  },


  // 智慧养老解决方案
  {
    path: '/solutionRetirement',
    name: 'solutionRetirement',
    meta: {
      menulist: [
        {
          name: '解决方案',
          path: '',
        },
        {
          name: '首页',
          path: '/solution',
        },
        {
          name: '智慧消防解决方案',
          path: '/solutionFireProtection',
        },
        {
          name: '智慧养老解决方案',
          path: '/solutionRetirement',
        }
      ]
    },
    component: () => import('../views/solution/solutionRetirement.vue'),
  },

  // 智慧社区解决方案
  {
    path: '/solutionCommunity',
    name: 'solutionCommunity',
    meta: {
      menulist: [
        {
          name: '解决方案',
          path: '',
        },
        {
          name: '首页',
          path: '/solution',
        },
        {
          name: '智慧消防解决方案',
          path: '/solutionFireProtection',
        },
        {
          name: '智慧养老解决方案',
          path: '/solutionRetirement',
        },
        {
          name: '智慧社区解决方案',
          path: '/solutionCommunity',
        }
      ]
    },
    component: () => import('../views/solution/solutionCommunity.vue'),
  },

  // 农业灌溉解决方案
  {
    path: '/irrigationSystem',
    name: 'irrigationSystem',
    meta: {
      menulist: [
        {
          name: '解决方案',
          path: '',
        },
        {
          name: '首页',
          path: '/solution',
        },
        {
          name: '农业灌溉解决方案',
          path: '/irrigationSystem',
        }
      ]
    },
    component: () => import('../views/solution/irrigationSystem.vue'),
  },

  // 企业网站99元建站
  {
    path: '/companyWeb',
    name: 'companyWeb',
    meta: {
      menulist: [
        {
          name: '解决方案',
          path: '',
        },
        {
          name: '首页',
          path: '/solution',
        },
        // {
        //   name: '企业网站99元建站',
        //   path: '/companyWeb',
        // }
      ]
    },
    component: () => import('../views/solution/companyWeb.vue'),
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

export default router
